import type { StyleRule } from '@archipro-design/aria';

export const CollapsibleContainer: StyleRule<{
    contentHeight: string;
    transitionDuration: number;
}> = ({ contentHeight, transitionDuration }) => ({
    maxHeight: contentHeight,
    transition: `max-height ${transitionDuration}ms linear`,
    overflow: 'hidden',
});
